import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {Theme} from '@emotion/react';

const styledSection = ({theme}: {theme: Theme}) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.gap.desktop.lg};
`;

export const DesktopWrapper = styled.div`
  ${styledSection};
  padding: ${({theme}) => theme.padding.desktop.md};
`;

export const MobileWrapper = styled.div`
  ${styledSection};
`;
